<template>
  <div>
    <div class="status font-size-medium">
      Free {{ until }}
    </div>
    <time-buttons
        :disabled="freeMinutes < 5"
        :free-mins="freeMinutes"
        :loading="grabLoading"
        @time="grab"
        class="grab-buttons"
        grab
        v-model="open"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TimeButtons from '@/components/TimeButtons';
import {isSameDay, minutes} from '@/utils/dates';
import {bookingStart} from '@/utils/bookings-v1';
import {isAbsent} from '@/utils/null';

export default {
  name: 'HybridOfficeGrabMeeting',
  components: {TimeButtons},
  data() {
    return {
      open: false,
      grabLoading: false
    };
  },
  computed: {
    ...mapGetters('config', ['timeFormat', 'readOnlyMode']),
    ...mapGetters('hybridOffice/bookings', ['now', 'nextBooking']),
    freeMinutes() {
      if (!this.nextBooking) return Infinity;
      const nextStart = bookingStart(this.nextBooking, '');
      const now = this.now;
      return Math.trunc((nextStart.getTime() - now.getTime()) / minutes);
    },
    until() {
      if (!this.nextBooking) return 'all day';
      const nextStart = bookingStart(this.nextBooking, '');
      if (isAbsent(nextStart) || !isSameDay(nextStart, this.now)) {
        return 'all day';
      }
      return `until ${this.formatTime(nextStart)}`;
    }
  },
  methods: {
    ...mapActions('hybridOffice/bookings', ['createAdHocBooking']),
    grab(minutes) {
      this.grabLoading = true;
      this.createAdHocBooking(minutes)
          .catch(err => {
            this.$logger.error(err);
            this.$notify.showError('Error grabbing room, please try again');
          })
          .finally(() => {
            this.grabLoading = false;
          });
    }
  }
};
</script>

<style scoped>
.status {
  line-height: 1em;
  position: relative;
  top: calc(var(--grid-size) - 1em + 5px);
}

.grab-buttons {
  position: absolute;
  top: calc((2 * var(--grid-size)) - var(--button-height));
}

.offline-notification {
  position: absolute;
  top: calc((2 * var(--grid-size)));
  min-width: calc(1 * var(--button-width));
}
</style>
